import useServiceStatus from "../../../hooks/useServiceStatus";
import styles from "../../../styles/Components/new-insight/chart-section/InsightsSignalCard.module.css";
import { Skeleton, Tooltip } from "antd";
import { MdAccessTime } from "react-icons/md";
import LiveAiButton from "../../new-dashboard/LiveAIButton";
import { HiOutlineRefresh } from "react-icons/hi";
import HiddenContent from "../../../ui/HiddenContent";
import { useRelativeTime } from "../../../hooks/useRelativeTime";

function InsightsLiveSignalCard({ data, loading }) {
  const { isActive: isAiActive } = useServiceStatus("aiAssistant");
  const { isActive: isInsightActive } = useServiceStatus("insight");
  const isActive = isInsightActive;

  const signal = data?.prediction;
  const date = useRelativeTime(data?.signal_timestamp);

  // if (loading) return <Skeleton.Node className={styles.signalLoader} active />;

  return (
    <div
      className={`${styles.container} ${isActive ? styles?.[signal?.toLowerCase()] : ""}`}
    >
      <div className={styles.header}>
        <h4>Pivot (15m)</h4>
        <Tooltip
          title="Looks for a turn on the 15-minute chart. This is not the category call."
          color="geekblue"
          className={styles.description}
        >
          Looks for a turn
        </Tooltip>
        {isActive ? (
          <span
            className={`${styles.signal} ${styles?.[signal?.toLowerCase()]}`}
          >
            {loading ? (
              <Skeleton.Node className={styles.signalLoader} active />
            ) : (
              signal || "-"
            )}
          </span>
        ) : (
          <HiddenContent className={styles.signal} service="insai" />
        )}
      </div>

      <div className={styles.footer}>
        {!isActive ? (
          <HiddenContent service="insai" />
        ) : !data ? (
          <>
            {loading && <Skeleton.Node className={styles.timeLoading} active />}
            <LiveAiButton
              title="Run"
              icon={<HiOutlineRefresh />}
              coin={data?.symbol}
              className={styles.runAiButton}
            />
          </>
        ) : (
          <>
            <div className={styles.signalDate}>
              <MdAccessTime />
              {date}
            </div>
            <LiveAiButton
              title="Run"
              icon={<HiOutlineRefresh />}
              coin={data?.symbol}
              className={styles.runAiButton}
            />
          </>
        )}
        {/*{!isActive && <HiddenContent service="insai" />}*/}
        {/*{isActive && (*/}
        {/*  <div className={styles.signalDate}>*/}
        {/*    <MdAccessTime />*/}
        {/*    {date}*/}
        {/*  </div>*/}
        {/*)}*/}

        {/*{isActive && (*/}
        {/*  <LiveAiButton*/}
        {/*    title="Run"*/}
        {/*    icon={<HiOutlineRefresh />}*/}
        {/*    coin={data?.symbol}*/}
        {/*    className={styles.runAiButton}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
    </div>
  );
}

export default InsightsLiveSignalCard;
